/**
 * Angular imports.
 */
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * Environment imports.
 */
import { environment } from '../../../environments/environment';

/**
 * Library imports.
 */
import { CarouselConfig } from 'ngx-bootstrap/carousel';

/**
 * Model imports.
 */
import { Suggestion } from '../../interface/suggestion/suggestion';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { AuthService } from '../../auth/auth.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * Suggestion Right Component
 */
@Component({
  selector: 'app-suggestion-right',
  templateUrl: './suggestion-right.component.html',
  styleUrls: ['./suggestion-right.component.scss'],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 0, noPause: true } }
  ]
})

export class SuggestionRightComponent implements OnInit {

  @Input() product_type: number;
  @Input() profileObj;
  @Input() verificationData;

  public loginUserCustomeId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public user_profile_card: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public user_verification_data: any;
  public screen_name = '';
  public webSiteUrl = environment.baseUrls.webSiteUrl;
  public suggestionList: Suggestion[] = [];
  public isDocReqModalShown = false;
  public info_msg = '';
  public isInfoModalShown = false;
  public act_loader = false;
  public isErrorModalShown = false;
  public error_msg: string;

  /**
   * Necessary instances.
   */
  constructor(
    public dss: DataStorageService,
    public router: Router,
    public masterService: MasterserviceService,
    public ems: EventMsgService,
    public funCollectionService: FunCollectionService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public mls: NewLanguageService) {
    this.screen_name = route.snapshot.data['screen_name'];
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    this.user_verification_data = this.verificationData;
    this.user_verification_data = this.verificationData;
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.user_profile_card = this.profileObj;
    this.user_verification_data = this.verificationData;
    this.getSuggestionList();
  }

  /**
   * get Suggestion List
   */
  getSuggestionList(): void {
    // No Code
  }

  /**
   * navigate to cme section
   */
  navToCmeSection = function (cme_id): void {
    this.router.navigateByUrl('/cme/detail/' + cme_id);

  };

  /**
   * Call navigation function
   */
  navifateToProfile(): void {
    this.funCollectionService.navigateToUserProfie(this.loginUserCustomeId);
  }

  /**
   * reset Info Modal
   */
  resetInfoModal(): void {
    this.isInfoModalShown = false;
  }

  /**
   * reset Error Modal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
  }

  /**
   * http Error Handeler
   */
  httpErrorHandeler(): void {
    // Handle Error
  }

  /**
   * Error Handler
   */
  ErrorHandler(Err_msg): boolean {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
    return false;
  }
}
